function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import Evented from './Evented';
/**
 * Channel used for client subscriptions within a multiplexed connection
 */

var MultiplexChannel = /*#__PURE__*/function (_Evented) {
  _inheritsLoose(MultiplexChannel, _Evented);

  function MultiplexChannel(host, channelPath, opts) {
    var _this;

    _this = _Evented.call(this) || this;
    _this.lastMessageSequence = 0;
    _this.subscribers = 0;
    _this.host = host;
    _this.channelPath = channelPath;
    _this.options = opts;

    _this.subscribe();

    return _this;
  }

  var _proto = MultiplexChannel.prototype;

  _proto.subscribe = function subscribe() {
    if (this.subscribers < 1) {
      this.host.subscribeToChannel(this);
    }

    this.subscribers = this.subscribers + 1;
  };

  _proto.unsubscribe = function unsubscribe() {
    this.subscribers -= 1;

    if (this.subscribers < 1) {
      this.host.unsubscribeFromChannel(this);
      this.lastMessageSequence = 0;
      this.emit('destroy');
    }
  };

  _createClass(MultiplexChannel, [{
    key: "isConnected",
    get: function get() {
      return this.host.isConnected;
    }
  }, {
    key: "metrics",
    get: function get() {
      return {
        channelPath: this.channelPath,
        subscribers: this.subscribers,
        lastMessageSequence: this.lastMessageSequence
      };
    }
  }]);

  return MultiplexChannel;
}(Evented);

export { MultiplexChannel as default };